import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class ContabilidadPolizasexternasAlgodonerosPagosComprasComponent {
  constructor(PolizaExternasAlgodonerosPagosComprasService, $location, $moment) {
    this.PolizaExternasAlgodonerosPagosComprasService = PolizaExternasAlgodonerosPagosComprasService
    this.$location = $location
    this.$moment = $moment
  }

  $onInit() {
    this.movimiento = undefined
    this.opciones = {
      fechaInicio: this.busqueda.fechaInicio || this.$moment(new Date()).toDate(),
      fechaFin: this.busqueda.fechaFin || this.$moment(new Date()).toDate(),
    }
    this.promise = this.PolizaExternasAlgodonerosPagosComprasService.get(this.opciones)
      .then((resolve) => {
        this.data = resolve.data
      })
  }

  traerMovimientos() {
    if (this.opciones.fechaInicio && this.opciones.fechaFin) {
      this.PolizaExternasAlgodonerosPagosComprasService.get(this.opciones)
        .then((resolve) => {
          this.data = resolve.data
        })
    }
  }

  buscar() {
    this.$location.search({
      fechaInicio: this.$moment(this.opciones.fechaInicio).format('YYYY-MM-DD'),
      fechaFin: this.$moment(this.opciones.fechaFin).format('YYYY-MM-DD'),
      idMovimientos: this.opciones.idMovimientos,
    })
  }
}

module.component('contabilidadPolizasexternasAlgodonerosPagosCompras', {
  controller: ContabilidadPolizasexternasAlgodonerosPagosComprasComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/pagos-compras/component.js